import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


const TabContentContainer = ({ children, extraClassName }) => (
  <div className={classNames(styles.tabItem, extraClassName)}>
    {children}
  </div>
);

TabContentContainer.propTypes = {
  url: PropTypes.string,
  extraClassName: PropTypes.string,
};

TabContentContainer.defaultProps = {
  children: null,
  url: '',
  extraClassName: '',
};

export default TabContentContainer;
